import { getFileTypeFromName } from '@/helpers/fileTypeDeterminant'

export const ALLOWED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp']
export const ALLOWED_IMAGE_MIME = ['image/jpeg', 'image/png', 'image/webp']
export const UNSUPPORTED_IMAGE_MESSAGE = 'Файл не поддерживается. Поддерживаемые форматы: JPEG, PNG, JPG, WEBP'
export const INVALID_IMAGE_FORMAT_MESSAGE =
	'Неверный формат файла. Выберите изображение в формате: JPEG, PNG, JPG или WEBP'

export function isAllowedImageFile(file: File): boolean {
	const ext = getFileTypeFromName(file.name).toLowerCase()
	const mimeOk = file.type ? ALLOWED_IMAGE_MIME.includes(file.type) : true
	return ALLOWED_IMAGE_EXTENSIONS.includes(ext) && mimeOk
}
